/**
 * The version of the build the person is actually looking at.
 *
 * Stamped in at build time from `package.json` (`define` in vite.config.ts) rather than typed
 * out here, because the one place it is sent — the legal acceptance record — is evidence: an
 * acceptance row saying «web 0.1.0» has to mean the bundle that rendered the text, not a
 * constant somebody forgot to bump.
 *
 * The fallback exists for the case where the define did not run (a bare `vitest` invocation with
 * a different config, a REPL): an obviously wrong `0.0.0` beats a crash on a legal screen.
 */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION ?? '0.0.0';
